import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ChangeDetectionStrategy
} from '@angular/core';
import { Subscription, timer } from 'rxjs';
import { alertProps } from './alert.utils';

@Component({
  selector: 'cohrex-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AlertComponent implements OnInit, OnChanges {
  props: string = '';
  alertTimeOut: number = 10; // in seconds

  private _color?: string = 'primary';
  @Input()
  set color(value: string | undefined) {
    this._color = value;
  }
  get color(): string | undefined {
    return this._color;
  }

  private _visible?: boolean = false;
  @Input()
  set visible(value: boolean | undefined) {
    this._visible = value;
  }
  get visible(): boolean | undefined {
    return this._visible;
  }

  @Output()
  closeAlert: EventEmitter<boolean> = new EventEmitter<boolean>();

  timerSubscription!: Subscription;

  ngOnInit(): void {
    this.initProps();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initProps();
    const source = timer(1000, 1000);
    if (changes['visible']?.currentValue) {
      this.timerSubscription = source.subscribe((val) => {
        if (val++ >= this.alertTimeOut) {
          this.handleClose();
        }
      });
    }
  }

  initProps() {
    this.props = alertProps({
      color: this.color
    })?.toString();
  }

  handleClose() {
    this.closeAlert.emit(this.visible);
    this.timerSubscription.unsubscribe();
  }
}
